import React from 'react';
import Icon from '../../../components/AppIcon';

const AuthTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    {
      id: 'login',
      label: 'Sign In',
      icon: 'LogIn',
      description: 'Access your account'
    },
    {
      id: 'register',
      label: 'Sign Up',
      icon: 'UserPlus',
      description: 'Create new account'
    }
  ];

  return (
    <div className="mb-8">
      <div className="flex bg-muted rounded-lg p-1">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`
              flex-1 flex items-center justify-center space-x-2 px-4 py-3 rounded-md text-sm font-medium
              transition-all duration-200 relative
              ${activeTab === tab.id
                ? 'bg-card text-foreground shadow-soft'
                : 'text-muted-foreground hover:text-foreground'
              }
            `}
          >
            <Icon name={tab.icon} size={16} />
            <span>{tab.label}</span>
          </button>
        ))}
      </div>
      
      <div className="text-center mt-4">
        <p className="text-sm text-muted-foreground">
          {activeTab === 'login' ?'Welcome back! Please sign in to your account.' :'Join Dru Travels and start your journey with us.'
          }
        </p>
      </div>
    </div>
  );
};

export default AuthTabs;